import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Aside from "./Aside";
import Footer from "./Footer";
import axios from '../../axios/axiosconf';

function Home() {
    const [loading, setLoading] = useState(true);
    const [indicadores, setIndicadores] = useState({
        total_pacientes: 0,
        citas_hoy: 0,
        facturas_mes: 0,
        rips_pendientes: 0
    });
    const [notas, setNotas] = useState([]);
    const [noticias, setNoticias] = useState([]);
    const [showModalNota, setShowModalNota] = useState(false);
    const [nuevaNota, setNuevaNota] = useState({
        titulo: '',
        contenido: '',
        tipo: 'nota',
        color: 'info',
        fecha_recordatorio: ''
    });
    
    // 🆕 Estados para notificaciones de facturas
    const [notificacionesFacturas, setNotificacionesFacturas] = useState({
        facturas: [],
        estadisticas: {
            total_vencidas: 0,
            total_proximas_vencer: 0,
            total_pendientes_envio: 0,
            valor_total_vencidas: 0,
            valor_total_proximas: 0
        }
    });
    
    // 🆕 Estado del cliente (para notificación de vencimiento)
    const [clienteInfo, setClienteInfo] = useState({
        estado: 0,
        fecha_vencimiento: null,
        dias_para_vencer: null
    });

    // Obtener userdata del localStorage
    const userdata = JSON.parse(localStorage.getItem('userdata')) || { name: 'Usuario' };

    useEffect(() => {
        // Limpiar mensajes de toast del localStorage
        localStorage.removeItem('showtoast');
        localStorage.removeItem('toastmsg');
        localStorage.removeItem('toastdelay');
        
        cargarDashboard();
    }, []);

    const cargarDashboard = async () => {
        setLoading(true);
        
        console.log('=== INICIO CARGA DASHBOARD ===');
        console.log('User ID:', userdata.user_id);
        console.log('Client ID:', userdata.client_id);
        console.log('UserData completo:', userdata);
        console.log('Name:', userdata.name);
        console.log('Lastname:', userdata.lastname);
        console.log('User Name:', userdata.user_name);
        console.log('User Lastname:', userdata.user_lastname);
        
        // Cargar indicadores (con manejo de error independiente)
        try {
            console.log('Cargando indicadores...');
            // 🔒 Ya no necesitamos enviar uid - se obtiene del token JWT
            const respIndicadores = await axios.get('/dashboard/indicadores');
            console.log('Indicadores recibidos:', respIndicadores.data);
            setIndicadores(respIndicadores.data);
        } catch (error) {
            console.error('Error al cargar indicadores:', error);
            console.error('Continuando con valores por defecto...');
            setIndicadores({
                total_pacientes: 0,
                citas_hoy: 0,
                facturas_mes: 0,
                rips_pendientes: 0
            });
        }

        // Cargar notas (independiente de los indicadores)
        try {
            const urlNotas = `/dashboard/notas?uid=${userdata.user_id}&limit=3&activos=1`;
            console.log('URL de notas:', urlNotas);
            console.log('Cargando notas...');
            
            const respNotas = await axios.get(urlNotas);
            console.log('Respuesta completa de notas:', respNotas);
            console.log('Notas recibidas:', respNotas.data);
            console.log('Cantidad de notas:', respNotas.data.length);
            console.log('Tipo de datos:', typeof respNotas.data);
            console.log('Es array?:', Array.isArray(respNotas.data));
            
            setNotas(respNotas.data);
            console.log('Notas guardadas en estado');
        } catch (error) {
            console.error('Error al cargar notas:', error);
            if (error.response) {
                console.error('Status:', error.response.status);
                console.error('Data:', error.response.data);
            }
            setNotas([]);
        }
        
        // Cargar noticias del sistema
        try {
            console.log('Cargando noticias del sistema...');
            const respNoticias = await axios.get('/noticias-activas');
            console.log('Noticias recibidas:', respNoticias.data);
            setNoticias(respNoticias.data);
        } catch (error) {
            console.error('Error al cargar noticias:', error);
            setNoticias([]);
        }
        
        // 🆕 Cargar notificaciones de facturas vencidas
        try {
            console.log('Cargando notificaciones de facturas...');
            const respNotificaciones = await axios.get('/test/notificaciones'); // Usar ruta de prueba temporalmente
            console.log('Notificaciones recibidas:', respNotificaciones.data);
            console.log('Total vencidas:', respNotificaciones.data.estadisticas?.total_vencidas);
            console.log('Total próximas:', respNotificaciones.data.estadisticas?.total_proximas_vencer);
            setNotificacionesFacturas(respNotificaciones.data);
        } catch (error) {
            console.error('Error al cargar notificaciones de facturas:', error);
            console.error('Status:', error.response?.status);
            console.error('Data:', error.response?.data);
            setNotificacionesFacturas({
                facturas: [],
                estadisticas: {
                    total_vencidas: 0,
                    total_proximas_vencer: 0,
                    total_pendientes_envio: 0,
                    valor_total_vencidas: 0,
                    valor_total_proximas: 0
                }
            });
        }
        
        // 🆕 Cargar información del cliente (para notificación de vencimiento)
        try {
            console.log('Cargando información del cliente...');
            const respCliente = await axios.get('/dashboard/cliente-info');
            console.log('Info cliente recibida:', respCliente.data);
            setClienteInfo(respCliente.data);
        } catch (error) {
            console.error('Error al cargar info del cliente:', error);
            setClienteInfo({
                estado: 0,
                fecha_vencimiento: null,
                dias_para_vencer: null
            });
        }
        
        setLoading(false);
        console.log('=== FIN CARGA DASHBOARD ===');
    };

    const crearNotaRapida = async (e) => {
        e.preventDefault();
        
        try {
            await axios.post(`/dashboard/notas?uid=${userdata.user_id}`, nuevaNota);
            setShowModalNota(false);
            setNuevaNota({
                titulo: '',
                contenido: '',
                tipo: 'nota',
                color: 'info',
                fecha_recordatorio: ''
            });
            cargarDashboard();
        } catch (error) {
            console.error('Error al crear nota:', error);
            alert('Error al crear la nota');
        }
    };

    const getColorClass = (color) => {
        const colores = {
            'info': 'bg-info',
            'warning': 'bg-warning',
            'danger': 'bg-danger',
            'success': 'bg-success',
            'primary': 'bg-primary'
        };
        return colores[color] || 'bg-info';
    };

    const getTipoIcon = (tipo) => {
        const iconos = {
            'nota': 'fas fa-sticky-note',
            'recordatorio': 'fas fa-bell',
            'importante': 'fas fa-exclamation-circle'
        };
        return iconos[tipo] || 'fas fa-sticky-note';
    };

    // Funciones helper para noticias del sistema
    const getNoticiaAlertClass = (tipo) => {
        const classes = {
            'info': 'alert-info',
            'secondary': 'alert-secondary',
            'light': 'alert-light',
            'dark': 'alert-dark',
            'warning': 'alert-warning',
            'danger': 'alert-danger',
            'success': 'alert-success'
        };
        return classes[tipo] || 'alert-info';
    };

    const getNoticiaIcon = (tipo) => {
        const iconos = {
            'info': 'fas fa-info-circle',
            'secondary': 'fas fa-circle',
            'light': 'fas fa-circle',
            'dark': 'fas fa-circle',
            'warning': 'fas fa-exclamation-triangle',
            'danger': 'fas fa-times-circle',
            'success': 'fas fa-check-circle'
        };
        return iconos[tipo] || 'fas fa-info-circle';
    };

    const formatearFechaNoticia = (fecha) => {
        if (!fecha) return '';
        const date = new Date(fecha);
        return date.toLocaleDateString('es-CO', { 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
        });
    };

    // 🆕 Funciones helper para notificaciones de facturas
    const formatearValor = (valor) => {
        return '$' + Math.round(parseFloat(valor || 0)).toLocaleString('es-CO');
    };

    const formatearFecha = (fecha) => {
        if (!fecha) return '';
        const date = new Date(fecha);
        return date.toLocaleDateString('es-CO');
    };

    const getColorNotificacion = (tipo) => {
        return tipo === 'vencida' ? 'danger' : 'warning';
    };

    const getIconoNotificacion = (tipo) => {
        return tipo === 'vencida' ? 'fas fa-exclamation-triangle' : 'fas fa-clock';
    };

    const verEstadoCuentaPaciente = (pacienteId) => {
        window.open(`/smile/#/estado-cuenta-paciente?id=${pacienteId}`, '_blank');
    };

    return (
        <div className="hold-transition">
            <Header />
            <Aside activelink="home" />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                 <h2 className="card-title">
                                    Bienvenido, {userdata?.name || userdata?.user_name || 'Usuario'} {userdata?.lastname || userdata?.user_lastname || ''}
                                </h2>
                            </div>
                            <div className="col-sm-6">
                                <div className="float-right">
                                    <Link to="/busqueda-citas" className="btn btn-primary btn-sm mr-2">
                                        <i className="fas fa-search"></i> Buscar Citas
                                    </Link>
                                    <Link to="/control-asistencia" className="btn btn-primary btn-sm">
                                        <i className="far fa-calendar-alt"></i> Control Asistencia
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">
                        {loading ? (
                            <div className="text-center">
                                <i className="fas fa-spinner fa-spin fa-3x"></i>
                            </div>
                        ) : (
                            <>
                                {/* INDICADORES KPI */}
                                <div className="row">
                                    <div className="col-lg-3 col-6">
                                        <div className="small-box bg-custom-dark">
                                            <div className="inner">
                                                <h3>{indicadores.total_pacientes}</h3>
                                                <p>Pacientes Registrados</p>
                                            </div>
                                            <div className="icon">
                                                <i className="fas fa-user-plus"></i>
                                            </div>
                                            <Link to="/pacientes" className="small-box-footer">
                                                Ver Pacientes <i className="fas fa-arrow-circle-right"></i>
                                            </Link>
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-6">
                                        <div className="small-box bg-custom-dark">
                                            <div className="inner">
                                                <h3>{indicadores.citas_hoy}</h3>
                                                <p>Citas de Hoy</p>
                                            </div>
                                            <div className="icon">
                                                <i className="far fa-calendar-alt"></i>
                                            </div>
                                            <Link to="/lista-citas" className="small-box-footer">
                                                Ver Citas <i className="fas fa-arrow-circle-right"></i>
                                            </Link>
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-6">
                                        <div className="small-box bg-custom-dark">
                                            <div className="inner">
                                                <h3>{indicadores.facturas_mes}</h3>
                                                <p>Facturas del Mes</p>
                                            </div>
                                            <div className="icon">
                                                <i className="fas fa-file-invoice-dollar"></i>
                                            </div>
                                            <Link to="/listado-facturas" className="small-box-footer">
                                                Ver Facturas <i className="fas fa-arrow-circle-right"></i>
                                            </Link>
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-6">
                                        <div className="small-box bg-custom-dark">
                                            <div className="inner">
                                                <h3>{indicadores.rips_pendientes}</h3>
                                                <p>RIPS Registrados</p>
                                            </div>
                                            <div className="icon">
                                                <i className="fas fa-file-medical"></i>
                                            </div>
                                            <Link to="/listado-rips" className="small-box-footer">
                                                Ver RIPS <i className="fas fa-arrow-circle-right"></i>
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                                {/* NOTICIAS DEL SISTEMA */}
                                {noticias.length > 0 && (
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            {noticias.map(noticia => (
                                                <div 
                                                    key={noticia.id} 
                                                    className={`alert ${getNoticiaAlertClass(noticia.tipo)} alert-dismissible fade show`}
                                                    role="alert"
                                                >
                                                    <h5>
                                                        <i className={getNoticiaIcon(noticia.tipo)}></i> {noticia.titulo}
                                                    </h5>
                                                    <p className="mb-1">{noticia.contenido}</p>
                                                    {noticia.fecha_fin && (
                                                        <small className="d-block mt-2">
                                                            <i className="fas fa-calendar"></i> Válido hasta: {formatearFechaNoticia(noticia.fecha_fin)}
                                                        </small>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                {/* 🆕 NOTIFICACIÓN DE VENCIMIENTO DEL CLIENTE */}
                                {clienteInfo.estado === 3 && clienteInfo.dias_para_vencer !== null && clienteInfo.dias_para_vencer <= 10 && (
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <div className="alert alert-warning alert-dismissible fade show" role="alert">
                                                <h5>
                                                    <i className="fas fa-exclamation-triangle"></i> Su suscripción está próxima a vencer
                                                </h5>
                                                <p className="mb-1">
                                                    Su plan vence el <strong>{formatearFecha(clienteInfo.fecha_vencimiento)}</strong> ({clienteInfo.dias_para_vencer} días restantes).
                                                    Recuerde realizar el pago de su suscripción.
                                                </p>
                                                <button type="button" className="close" data-dismiss="alert">
                                                    <span>&times;</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* 🆕 NOTIFICACIONES DE FACTURACIÓN */}
                                {(notificacionesFacturas.estadisticas.total_vencidas > 0 || notificacionesFacturas.estadisticas.total_pendientes_envio > 0) && (
                                    <div className="row mb-3">
                                        {/* Facturas Vencidas */}
                                        {notificacionesFacturas.estadisticas.total_vencidas > 0 && (
                                            <div className="col-md-12 mb-2">
                                                <div className="card card-outline card-danger">
                                                    <div className="card-body">
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div>
                                                                <h5 className="text-danger mb-1">
                                                                    <i className="fas fa-exclamation-triangle"></i> Facturas Vencidas
                                                                </h5>
                                                                <h3 className="mb-0">{notificacionesFacturas.estadisticas.total_vencidas}</h3>
                                                                <small className="text-muted">
                                                                    Saldo: {formatearValor(notificacionesFacturas.estadisticas.valor_total_vencidas)}
                                                                </small>
                                                            </div>
                                                            <Link to="/listado-facturas?filtro=vencidas" className="btn btn-outline-danger">
                                                                <i className="fas fa-list"></i> Ver
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Facturas Pendientes de Envío a DIAN */}
                                        {notificacionesFacturas.estadisticas.total_pendientes_envio > 0 && (
                                            <div className="col-md-12">
                                                <div className="card card-outline card-primary">
                                                    <div className="card-body">
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div>
                                                                <h5 className="text-primary mb-1">
                                                                    <i className="fas fa-file-invoice"></i> Pendientes DIAN
                                                                </h5>
                                                                <h3 className="mb-0">{notificacionesFacturas.estadisticas.total_pendientes_envio}</h3>
                                                                <small className="text-muted">
                                                                    Borradores y con errores
                                                                </small>
                                                            </div>
                                                            <Link to="/listado-facturas?filtro=pendientes" className="btn btn-outline-primary">
                                                                <i className="fas fa-list"></i> Ver
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}

                                {/* NOTAS Y ACTIVIDAD RECIENTE */}
                                <div className="row">
                                    {/* NOTAS Y RECORDATORIOS */}
                                    <div className="col-md-6">
                                        <div className="card">
                                            <div className="card-header">
                                                <h3 className="card-title">
                                                    <i className="fas fa-sticky-note"></i> Notas y Recordatorios
                                                </h3>
                                                <div className="card-tools">
                                                    <button 
                                                        className="btn btn-primary btn-sm"
                                                        onClick={() => setShowModalNota(true)}
                                                    >
                                                        <i className="fas fa-plus"></i> Nueva Nota
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="card-body">
                                                {console.log('Renderizando notas. Total:', notas.length, 'Notas:', notas)}
                                                {notas.length === 0 ? (
                                                    <p className="text-muted">No hay notas pendientes. <br/><small>Las notas completadas se ocultan del dashboard.</small></p>
                                                ) : (
                                                    <div className="timeline">
                                                        {notas.map(nota => {
                                                            console.log('Renderizando nota individual:', nota);
                                                            return (
                                                            <div key={nota.id}>
                                                                <i className={`${getTipoIcon(nota.tipo)} ${getColorClass(nota.color)}`}></i>
                                                                <div className="timeline-item">
                                                                    <h3 className="timeline-header">
                                                                        <strong>{nota.titulo}</strong>
                                                                    </h3>
                                                                    <div className="timeline-body">
                                                                        {nota.contenido}
                                                                    </div>
                                                                    {nota.fecha_recordatorio && (
                                                                        <div className="timeline-footer">
                                                                            <small className="text-muted">
                                                                                <i className="fas fa-calendar"></i> {nota.fecha_recordatorio}
                                                                            </small>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        );
                                                        })}
                                                        <div>
                                                            <i className="fas fa-clock bg-gray"></i>
                                                        </div>
                                                    </div>
                                                )}
                                                <div className="text-center mt-3">
                                                    <Link to="/administrar-notas" className="btn btn-sm btn-secondary">
                                                        Ver Todas las Notas
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* ACCESOS RÁPIDOS */}
                                    <div className="col-md-6">
                                        <div className="card">
                                            <div className="card-header">
                                                <h3 className="card-title">
                                                    <i className="fas fa-bolt"></i> Accesos Rápidos
                                                </h3>
                                            </div>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-6 mb-3">
                                                        <Link to="/agendar-cita" className="btn btn-app btn-block">
                                                            <i className="fas fa-calendar-plus"></i> Agendar Cita
                                                        </Link>
                                                    </div>
                                                    <div className="col-6 mb-3">
                                                        <Link to="/crear-factura" className="btn btn-app btn-block">
                                                            <i className="fas fa-file-invoice"></i> Nueva Factura
                                                        </Link>
                                                    </div>
                                                    <div className="col-6 mb-3">
                                                        <Link to="/pacientes" className="btn btn-app btn-block">
                                                            <i className="fas fa-user-plus"></i> Nuevo Paciente
                                                        </Link>
                                                    </div>
                                                    <div className="col-6 mb-3">
                                                        <Link to="/listado-rips" className="btn btn-app btn-block">
                                                            <i className="fas fa-file-medical"></i> Consultar RIPS
                                                        </Link>
                                                    </div>
                                                    <div className="col-6 mb-3">
                                                        <Link to="/crear-documento-soporte" className="btn btn-app btn-block">
                                                            <i className="fas fa-file-alt"></i> Doc. Soporte
                                                        </Link>
                                                    </div>
                                                    <div className="col-6 mb-3">
                                                        <Link to="/indicadores" className="btn btn-app btn-block">
                                                            <i className="fas fa-chart-line"></i> Indicadores
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </section>
            </div>

            {/* Modal para crear nota rápida */}
            <div className={`modal fade ${showModalNota ? 'show' : ''}`} 
                 style={{ display: showModalNota ? 'block' : 'none' }}
                 tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <form onSubmit={crearNotaRapida}>
                            <div className="modal-header">
                                <h4 className="modal-title">Nueva Nota Rápida</h4>
                                <button type="button" className="close" onClick={() => setShowModalNota(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                    <label>Título *</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={nuevaNota.titulo}
                                        onChange={(e) => setNuevaNota({...nuevaNota, titulo: e.target.value})}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Contenido *</label>
                                    <textarea
                                        className="form-control"
                                        rows="3"
                                        value={nuevaNota.contenido}
                                        onChange={(e) => setNuevaNota({...nuevaNota, contenido: e.target.value})}
                                        required
                                    ></textarea>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Tipo</label>
                                            <select
                                                className="form-control"
                                                value={nuevaNota.tipo}
                                                onChange={(e) => setNuevaNota({...nuevaNota, tipo: e.target.value})}
                                            >
                                                <option value="nota">Nota</option>
                                                <option value="recordatorio">Recordatorio</option>
                                                <option value="importante">Importante</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Color</label>
                                            <select
                                                className="form-control"
                                                value={nuevaNota.color}
                                                onChange={(e) => setNuevaNota({...nuevaNota, color: e.target.value})}
                                            >
                                                <option value="info">Azul</option>
                                                <option value="warning">Amarillo</option>
                                                <option value="danger">Rojo</option>
                                                <option value="success">Verde</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                {nuevaNota.tipo === 'recordatorio' && (
                                    <div className="form-group">
                                        <label>Fecha de Recordatorio</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={nuevaNota.fecha_recordatorio}
                                            onChange={(e) => setNuevaNota({...nuevaNota, fecha_recordatorio: e.target.value})}
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModalNota(false)}>
                                    Cancelar
                                </button>
                                <button type="submit" className="btn btn-primary">
                                    Crear Nota
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {showModalNota && <div className="modal-backdrop fade show"></div>}

            <Footer showToast={false} />
        </div>
    );
}

export default Home;
